// Global (document-level) click listener must only be bound once no matter
// how many <quick-add-modal> instances exist on the page.
let globalQuickAddListenersBound = false;

function bindGlobalQuickAddListeners() {
  if (globalQuickAddListenersBound) return;
  globalQuickAddListenersBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-add-open]');
    if (!trigger) return;
    event.preventDefault();

    document.dispatchEvent(
      new CustomEvent('quick-add:open', {
        detail: {
          handle: trigger.dataset.productHandle,
          variantId: trigger.dataset.variantId || null,
        },
      })
    );
  });
}

class QuickAddModal extends HTMLElement {
  connectedCallback() {
    bindGlobalQuickAddListeners();

    this.panel = this.querySelector('.quick-add-modal__panel');
    this.body = this.querySelector('[data-quick-add-body]');
    this.lastFocused = null;
    this.requestToken = 0;

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-quick-add-close]')) this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || this.hidden) return;
      this.close();
    });

    document.addEventListener('quick-add:open', (event) => {
      this.open(event.detail.handle, event.detail.variantId);
    });

    // Once the product is actually added to cart, hand off to the flyout
    // cart rather than leaving both dialogs open at once.
    document.addEventListener('cart:added', () => this.close());
  }

  async open(handle, variantId) {
    if (!handle) return;

    this.lastFocused = document.activeElement;
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    this.classList.add('loading');
    this.body.innerHTML = '';

    const token = ++this.requestToken;

    try {
      const url = variantId ? `/products/${handle}?variant=${variantId}` : `/products/${handle}`;
      const response = await fetch(url);
      const html = await response.text();

      // The customer may have closed the modal (or triggered a different
      // product) while this request was in flight - drop stale responses.
      if (token !== this.requestToken || this.hidden) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('product-page');
      this.body.innerHTML = content ? content.outerHTML : this.errorMarkup();
      if (content) document.dispatchEvent(new CustomEvent('quick-add:loaded'));
    } catch (error) {
      if (token !== this.requestToken || this.hidden) return;
      this.body.innerHTML = this.errorMarkup();
    } finally {
      if (token === this.requestToken) {
        this.classList.remove('loading');
        this.panel.focus();
      }
    }
  }

  errorMarkup() {
    const message = this.dataset.errorMessage || 'Sorry, this product could not be loaded.';
    return `<p class="quick-add-modal__error">${message}</p>`;
  }

  close() {
    if (this.hidden) return;
    this.hidden = true;
    document.body.style.overflow = '';
    this.body.innerHTML = '';
    this.requestToken += 1;
    if (this.lastFocused) this.lastFocused.focus();
  }
}

// Guarded because this file can legitimately be requested more than once on
// the same page (the modal loads it globally, and a customer viewing a
// product page also has that page's own copy) - re-registering throws.
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', QuickAddModal);
}
